const applicantField = {
    applicantDataInfo: {
        title: '要保人基本資料',
        name: '要保人變更為',
        engName: '要保人英文譯音',
        id: '身分證字號',
        birthday: '出生日期',
        country: '國籍',
        relation: '與被保險人關係',
    },
    profession: {
        title: '職業內容',
        unit: '服務單位',
        nature: '營業性質',
        position: '職位',
        content: '工作內容(含兼職)',
        code: '職業代碼',
        partTimeCode: '兼職代碼',
        partTimeContent: '兼職工作內容',
    },
    connectionInfo: {
        title: '要保人聯絡資訊',
        applicantInfoAddress: '住所（戶籍地址）',
        chargeInfoAddress: '收費地址',
        applicantInfoTel: '要保人(戶籍)電話',
        chargeInfoTel: '收費地址市話',
        mobileCountry: '',
        mobile: '行動電話',
        email: 'E-mail',
    },
    record: {
        transDate: '申請日期',
        aplCatlText: '申請項目',
        fullPolicyNo: '保單號碼',
        regiNo: '受理案號',
        reserveTime: '視訊時間',
    },
};
Object.freeze(applicantField);
export default applicantField;
